export default "__VITE_ASSET__C1HR$U4F__"